import { FormFieldCustomSchema } from 'app/shared/models/form';

export const NARRATIVE_CONTENT_FIELD: FormFieldCustomSchema<string> = {
  name: 'narrative',
  required: true,
  type: 'CUSTOM',
};
